import React, {useContext, useState, useEffect} from 'react';
import './Banners.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { CheckSolidIcon, XSolidIcon } from '../../../assets/icons/icons';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import DeleteBannersDialog from './DeleteBannersDialog';
import ManageBannersDialog from './ManageBannersDialog';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getBanners) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getBanners()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Fermata' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

const DefaultCell = (params) => {
    if(params.value === 'Y'){
        return <CheckSolidIcon addClass='green-txt'/>
    }else{
        return <XSolidIcon addClass='red-txt'/>
    }
}

function Banners(props) {
    const auth = useContext(AuthContext);
    const { banners, setBanners } = useContext(AppAuthGlobalVariables);
    const { notificationSuccess, notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [bannersLoading, setBannersLoading] = useState(true);

    const [openManageBannersDialog, setOpenManageBannersDialog] = useState(false);
    const [openDeleteBannersDialog, setOpenDeleteBannersDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManageBannersDialog, getBanners), renderCell: (params) => ActionCell(params, handleOpenManageBannersDialog, handleOpenDeleteBannersDialog)},
        /* {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Numero Fermata', type: 'string', width: 150, align: 'right', headerAlign: 'right', valueGetter: (params) => params?.S}, */
        {field: 'descrizione', headerClassName: 'header-cell descrizione', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        /* {field: 'itbigimg', headerClassName: 'header-cell itbigimg', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'itsmallimg', headerClassName: 'header-cell itsmallimg', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'enbigimg', headerClassName: 'header-cell enbigimg', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'ensmallimg', headerClassName: 'header-cell ensmallimg', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S}, */
        {field: 'flagDefault', headerClassName: 'header-cell default', headerName: 'Default Banner', type: 'string', width: 100, align: 'center', headerAlign: 'center', valueGetter: (params) => params?.S, renderCell: (params) => DefaultCell(params)},
    ]

    useEffect(() => {
        if(!banners.length || !banners.length){
            getBanners();
        }else{
            setBannersLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getBanners();
        }
    }, [props.city])

    const getBanners = async(mustUpdateDefault=false, newDefaultIdEntita = '') => {

        try {
            setLoading(true);
            setBannersLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-banners',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const responseGet = await axios(axiosParams);
            setBanners(responseGet.data.dataToReturn);
            if(mustUpdateDefault){
                let flagDefaultsRows = responseGet.data.dataToReturn.filter(el => el.flagDefault.S === 'Y');
                let oldDefaultRow = flagDefaultsRows.find(el => el.idEntita.S !== newDefaultIdEntita);

                const essentialData = {
                    idEntita: oldDefaultRow.idEntita.S,
                    city: oldDefaultRow.city.S,
                }
    
                const data = {
                    flagDefault: 'N'
                }
    
                const dataToPass = {
                    ExpressionAttributeNames: {},
                    ExpressionAttributeValues: {},
                    UpdateExpression: "SET",
                };
                
                let dataKeys = Object.keys(data);
                for (let index = 0; index < dataKeys.length; index++) {
                    const element = dataKeys[index];
                    
                    if(!data[element]){
                        delete data[element];
                    }else{
                        dataToPass.ExpressionAttributeNames['#'+element] = element
                        dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                        dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                    }
                }

                let form = new FormData();
    
                form.append('essentialData', JSON.stringify(essentialData));
                
                if(Object.keys(data).length){
                    form.append('data', JSON.stringify(dataToPass))
                }
    
                const axiosParams = {
                    url: '/mod-banner',
                    method: 'post',
                    baseURL: config.API_URL,
                    headers: { 
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                    },
                    data: form
                };
                await axios(axiosParams);
                notificationSuccess('Banner di default Aggiornato');

                getBanners();
            }
            //setRows(response.data.dataToReturn);
            setBannersLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setBannersLoading(false);
            setLoading(false);
        }
    }

    const handleOpenManageBannersDialog = (action) => {
        setOpenManageBannersDialog(action)
    }
    const handleCloseManageBannersDialog = () => {
        setOpenManageBannersDialog(false);
    }

    const handleOpenDeleteBannersDialog = () => {
        setOpenDeleteBannersDialog(true);
    }   
    const handleCloseDeleteBannersDialog = () => {
        setOpenDeleteBannersDialog(false);
    }

    return (
        <div className='component-container banners'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={banners}
                        columns={columns}
                        className="banners-table"
                        loading={bannersLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        //slots={{
                        //    toolbar: ()=>CustomToolbar(),
                        //}}
                    />
                </ThemeProvider>
            </div>
            <ManageBannersDialog {...{
                openManageBannersDialog,
                handleCloseManageBannersDialog,
                lastCellData,
                getBanners,
                city: props.city
            }}/>
            <DeleteBannersDialog {...{
                openDeleteBannersDialog,
                handleCloseDeleteBannersDialog,
                lastCellData,
                getBanners
            }}/>
        </div>
    )
}

export default Banners